import { getJdiOSFile } from '@/util';
import { getJdiosWebpImageUrl } from '@/util/getImg';

const FORBIDDEN403_IMAGE_PATH = 'mubla1/100745703525432944.png';

/** 403 无权限页插图（120×120 展示） */
export const FORBIDDEN403_IMAGE_URL = getJdiosWebpImageUrl(getJdiOSFile(FORBIDDEN403_IMAGE_PATH));

const FORBIDDEN403_PRELOAD_LINK_ID = 'forbidden-403-image-preload';

/** axios 跳 /403 前预拉插图，弱网下避免 LCP 落在文案 <p> 上 */
export function preloadForbidden403Image(imageUrl: string = FORBIDDEN403_IMAGE_URL): void {
  if (!imageUrl || typeof document === 'undefined') {
    return;
  }

  const existing = document.getElementById(FORBIDDEN403_PRELOAD_LINK_ID) as HTMLLinkElement | null;
  if (existing) {
    if (existing.href !== imageUrl) {
      existing.href = imageUrl;
    }
    return;
  }

  const link = document.createElement('link');
  link.id = FORBIDDEN403_PRELOAD_LINK_ID;
  link.rel = 'preload';
  link.as = 'image';
  link.href = imageUrl;
  link.setAttribute('fetchpriority', 'high');
  document.head.appendChild(link);
}
